import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { useRetrieveDocuments, useUploadDocument } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { DropZone } from "./dropZone";

import { Props } from "./types";
import styles from "./styles.scss";

function ElementAttachmentsUpload({ project, element, elementType }: Props) {
  const { t } = useTranslation();
  const { folder } = useRetrieveDocuments(project.uuid, "project");
  const { isRequestPending, uploadDocument } = useUploadDocument(folder);
  const { pushView } = useModal();

  return (
    <div>
      <DropZone
        className={styles.dropzone}
        drop={(file) =>
          !isRequestPending &&
          uploadDocument({
            namespace: project.uuid,
            type: "project",
            folder,
            file,
          })
        }
      >
        {({ isDraggingOver }) => (
          <div className={styles.attachmentsUploaderContent}>
            {isDraggingOver ? (
              <div className={styles.dropPreview}>
                <h2 className={styles.dropPreviewMessage}>
                  {t("documentUpload.message")}
                </h2>
              </div>
            ) : (
              <button
                className={styles.attachmentsButton}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  pushView({
                    key: UseCases.attachDocumentsToElement,
                    data: {
                      project,
                      elementId: element.uuid,
                      elementType,
                    },
                  });
                }}
              >
                + {t("attachments.add")}
              </button>
            )}
          </div>
        )}
      </DropZone>
    </div>
  );
}

export { ElementAttachmentsUpload };
